var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorWarningCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Error_Warning (Circle)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M32.4994 5.33398C17.7794 5.33398 5.83276 17.2807 5.83276 32.0006C5.83276 46.7206 17.7794 58.6673 32.4994 58.6673C47.2194 58.6673 59.1661 46.7206 59.1661 32.0006C59.1661 17.2807 47.2194 5.33398 32.4994 5.33398ZM32.4994 34.6673C31.0328 34.6673 29.8328 33.4673 29.8328 32.0006V21.334C29.8328 19.8673 31.0328 18.6673 32.4994 18.6673C33.9661 18.6673 35.1661 19.8673 35.1661 21.334V32.0006C35.1661 33.4673 33.9661 34.6673 32.4994 34.6673ZM35.1661 45.334H29.8328V40.0006H35.1661V45.334Z",
    fill: "#FFB300"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorWarningCircle);
export default __webpack_public_path__ + "static/media/error_warning_circle.f6abd5f19bd2f71847d7593ac49a802a.svg";
export { ForwardRef as ReactComponent };